<template>
    <header id="header" class="bg-wp-dark">
        <div class="container pt-4 pb-2">
            <div class="d-flex flex-wrap justify-content-between">
                <div class="col-12">
                    <h1 class="mt-0 fg-wp-light">Search</h1>
                    <p class=""></p>
                </div>
            </div>
        </div>
    </header>


    <header id="filter-bar" class="shadow bg-wp-congress py-1">
        <div class="container pt-4">    
            <div class="d-flex flex-wrap justify-content-start">
                <form class="mb-4 col-12 ">
                    <input type="search" class="form-control" placeholder="Search all content..." aria-label="Search" />
                </form>
            </div>
        </div>
    </header>

    <!-- Main content -->
    <main id="content" class="bg-wp-congress-light py-1">

    </main>
</template>
